export default __webpack_public_path__ + "static/media/netmaker.2b69fb3b.png";